import Downloading from './src/main.js'
export default Downloading
